define(function (require) {
	const tpl = require('./templates/t_itv_text_field.hbs');
	const baseElement = require('./v_itv_base_element');
	return baseElement.extend({
		template:tpl,
		templateHelpers:function(){
			//get baseElement Template Helpers
			var baseTH = baseElement.prototype.templateHelpers.apply(this);

			var self = this;
			var ret = {
				classes:'text-field-container' + 
					(self.model.get('isVisible') === false ? ' hidden':'') +
					(self.model.get('fullWidthField') === true ? ' full-width' : ''),
				customAttr:function(){
					var ret = self.model.get('customAttr');
					if(self.config.isInGrid){
						ret += 'specialType="grid" ';
					}
					if ( baseTH.tooltip )
					{
						ret+=' data-tooltip="' + baseTH.tooltip + '"';
					}
					return ret;
				},
				multiline: (self.config.gridField && self.model.get('isHtml')===true) ||self.model.get('maxLength') > 100 || ( self.model.get('multiline') && (self.model.get('multiline') == true || self.model.get('multiline').toLowerCase() == "true")),				
				type: 'text',
				valueHtmlRemoved: this.model.get('value') ? Handlebars.helpers['global:removeHTML'](this.model.get('value')) : ''
			};

			if (ret.multiline) {
				if (this.config.readOnlyForm)
					ret.valueHtmlRemoved = Handlebars.helpers['global:prepareMultilineValue'](this.model.get('value'), "<br />");
				else
					ret.valueHtmlRemoved = Handlebars.helpers['global:prepareMultilineValue'](this.model.get('value'), '\r');
			}

			ret = $.extend({},baseTH,ret);
			return ret;
		},
		getValue: function () {
			if (this.model.get('displayOnly') === true) {
				return;
			}
			if (this.model.get('isEnabled') === false || this.config.readOnlyForm) {
				//if we're disabled the value will be on the model.
				return this.model.get('value');
			}
			//larger text inputs are turned into text areas. So we have to check for both.
			if (this.$el.find('input').length != 0) {
				return this.$el.find('input').val();
			}
			//for multiline areas, we want to make sure we save with \n's, which IPS uses for text areas, over <br />, which are used for the less common HTML area
			return Handlebars.helpers['global:prepareMultilineValue'](this.$el.find('textarea').val(), '\n');
		}
	});
});
